"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MetricRing = MetricRing;
var _Text = _interopRequireDefault(require("react-native-web/dist/exports/Text"));
var _View = _interopRequireDefault(require("react-native-web/dist/exports/View"));
var _UiThemeProvider = require("../theme/UiThemeProvider");
var _color = require("../utils/color");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Web implementation of MetricRing using plain DOM SVG, so the web app does
 * not need react-native-svg (whose react-native peer dependency conflicts
 * with web-only installs). Bundlers that resolve `.web.js` first (CRA
 * webpack + jest, Expo web) pick this file; Metro picks MetricRing.tsx.
 *
 * Keep the rendered output visually identical to MetricRing.tsx.
 */
function MetricRing({
  progress,
  value,
  label,
  color,
  size = 84,
  strokeWidth = 7,
  style,
  ...rest
}) {
  const theme = (0, _UiThemeProvider.useUiTheme)();
  const ringColor = color ?? theme.palette.accentSolid;
  const clamped = Math.max(0, Math.min(1, progress));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
    ...rest,
    style: [{
      width: size,
      alignItems: 'center'
    }, style],
    accessibilityRole: "progressbar",
    accessibilityValue: {
      min: 0,
      max: 100,
      now: Math.round(clamped * 100)
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
      style: {
        width: size,
        height: size
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
        width: size,
        height: size,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
          cx: size / 2,
          cy: size / 2,
          r: radius,
          stroke: (0, _color.alpha)(ringColor, 0.18),
          strokeWidth: strokeWidth,
          fill: "none"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
          cx: size / 2,
          cy: size / 2,
          r: radius,
          stroke: ringColor,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          fill: "none",
          strokeDasharray: `${circumference}`,
          strokeDashoffset: circumference * (1 - clamped),
          transform: `rotate(-90 ${size / 2} ${size / 2})`
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
        style: {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          alignItems: 'center',
          justifyContent: 'center'
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          style: {
            fontSize: theme.fontSizes.subtitle,
            fontWeight: '700',
            color: theme.palette.text,
            fontVariant: ['tabular-nums']
          },
          children: value
        })
      })]
    }), label ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      style: {
        marginTop: 4,
        fontSize: theme.fontSizes.small,
        color: theme.palette.textSecondary,
        textAlign: 'center'
      },
      children: label
    }) : null]
  });
}